"use strict";
import { useDispatch } from "react-redux";
import { OnchainItemListOptionType } from "components/lists/items/types";
import { getNativeAddress } from "constants/uniswapAddresses";
import { SearchResultType } from "features/search/SearchResult";
import { addToSearchHistory } from "features/search/searchHistorySlice";
import { tokenAddressOrNativeAddress } from "features/search/utils";
export function useAddToSearchHistory() {
  const dispatch = useDispatch();
  const registerSearchItem = (item) => {
    switch (item.type) {
      case OnchainItemListOptionType.Pool:
        dispatch(addToSearchHistory({ searchResult: poolOptionToSearchResult(item) }));
        break;
      case OnchainItemListOptionType.Token:
        dispatch(addToSearchHistory({ searchResult: currencyInfoToTokenSearchResult(item.currencyInfo) }));
        break;
      case OnchainItemListOptionType.WalletByAddress:
      case OnchainItemListOptionType.Unitag:
      case OnchainItemListOptionType.ENSAddress:
        dispatch(
          addToSearchHistory({
            searchResult: { ...item, type: SearchResultType.WalletByAddress }
          })
        );
        break;
      case OnchainItemListOptionType.NFTCollection:
        dispatch(
          addToSearchHistory({
            searchResult: {
              ...item,
              type: SearchResultType.NFTCollection
            }
          })
        );
        break;
    }
  };
  const registerSearchTokenCurrencyInfo = (currencyInfo) => {
    dispatch(addToSearchHistory({ searchResult: currencyInfoToTokenSearchResult(currencyInfo) }));
  };
  return { registerSearchItem, registerSearchTokenCurrencyInfo };
}
function poolOptionToSearchResult(item) {
  const { chainId, poolId, token0CurrencyInfo, token1CurrencyInfo, protocolVersion, feeTier } = item;
  return {
    type: SearchResultType.Pool,
    chainId,
    poolId,
    token0CurrencyId: token0CurrencyInfo.currencyId,
    token1CurrencyId: token1CurrencyInfo.currencyId,
    protocolVersion,
    feeTier
  };
}
function currencyInfoToTokenSearchResult(currencyInfo) {
  const address = currencyInfo.currency.isToken ? currencyInfo.currency.address : getNativeAddress(currencyInfo.currency.chainId);
  return {
    type: SearchResultType.Token,
    chainId: currencyInfo.currency.chainId,
    address: tokenAddressOrNativeAddress(address, currencyInfo.currency.chainId),
    name: currencyInfo.currency.name ?? null,
    symbol: currencyInfo.currency.symbol ?? "",
    logoUrl: currencyInfo.logoUrl ?? null,
    safetyInfo: currencyInfo.safetyInfo,
    feeData: currencyInfo.currency.isToken ? {
      buyFeeBps: currencyInfo.currency.buyFeeBps?.gt(0) ? currencyInfo.currency.buyFeeBps.toString() : void 0,
      sellFeeBps: currencyInfo.currency.sellFeeBps?.gt(0) ? currencyInfo.currency.sellFeeBps.toString() : void 0
    } : null
  };
}
